import EventCourse from '@/components/events/EventCourse.vue';
import EventHome from '@/components/events/EventHome.vue';
import TypeHome from '@/components/events/TypeHome.vue';
import HUBStore from '@/store';
import HUBLog from '@/utils/logger';
import HUBValidation from '@/utils/validation';

const eventRouter = {
  routes: [
    {
      path: '/events',
      name: 'eventHome',
      component: EventHome,
    },
    {
      path: '/type-events/:typecode',
      name: 'typeEvents',
      component: TypeHome,
      props: true,
    },
    {
      path: '/event-course/:eventId',
      name: 'course',
      component: EventCourse,
      props(route) {
        return {
          eventId: parseInt(route.params.eventId, 10),
        };
      },
    },
    {
      path: '/type-event-course/:typecode/:eventId',
      name: 'typeEventCourse',
      component: EventCourse,
      props(route) {
        return {
          eventId: parseInt(route.params.eventId, 10),
        };
      },
    },
  ],
};

eventRouter.routes.forEach((r) => {
  const route = r;
  route.props = true;
});

eventRouter.guard = async (to) => {
  // Not a event page, go to next guard
  if (!HUBValidation.validateRoute(to.name, eventRouter.routes)) {
    return;
  }

  let levelUp;

  if (to.name === 'eventHome') {
    levelUp = { name: 'dashboard' };
  } else if (to.name === 'typeEvents') {
    levelUp = { name: 'eventHome' };
  } else if (to.name === 'course') {
    levelUp = { name: 'eventHome' };
  } else if (to.name === 'typeEventCourse') {
    levelUp = { name: 'typeEvents', params: { typecode: to.params.typecode } };
  }

  HUBStore.commit('setHUBSettingItems', {
    currentFunction: {
      key: 'professional-development',
      name: 'Professional Development',
    },
    levelUp,
  });

  HUBLog.debug(`Access: ${to.path}`);
  throw new Error();
};

export default eventRouter;
